import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {NgxTranslationsModule} from '@ngx-translations/translations.module';

import {NgxButton} from '@ngx-component-kit/forms/button/button.component';
import {NgxFormControl} from '@ngx-component-kit/forms/form-control/form-control.component';
import {NgxCheckbox} from '@ngx-component-kit/forms/checkbox/checkbox.component';
import {NgxGroup} from '@ngx-component-kit/forms/group/group.component';

import {NgxCard} from '@ngx-component-kit/cards/card/card.component';
import {NgxModal} from '@ngx-component-kit/cards/modal/modal.component';

import {NgxIcon} from '@ngx-component-kit/miscellaneous/icon/icon.component';
import {NgxLoading} from '@ngx-component-kit/miscellaneous/loading/loading.component';

import {NgxOutsideClick} from '@ngx-component-kit/directives/outside-click.directive';
import {NgxFocus} from '@ngx-component-kit/directives/focus.directive';
import {NgxTabs} from '@ngx-component-kit/cards/tabs/tabs.component';
import {NgxTabItem} from '@ngx-component-kit/cards/tab-item/tab-item.component';
import {NgxTable, NgxTableColumnDef} from '@ngx-component-kit/tables/table/table.component';
import {NgxTableBar} from '@ngx-component-kit/tables/table-bar/table-bar.component';
import {NgxTableCell} from '@ngx-component-kit/tables/table-cell/table-cell.component';
import {NgxTablePager} from '@ngx-component-kit/tables/table-pager/table-pager.component';

const DECLARATIONS_EXPORTS = [
    // Components.
    NgxButton,
    NgxFormControl,
    NgxGroup,
    NgxCheckbox,
    NgxCard,
    NgxModal,
    NgxTabs,
    NgxTabItem,
    NgxIcon,
    NgxLoading,
    NgxTable,
    NgxTableBar,
    NgxTableCell,
    NgxTablePager,
    // Directives.
    NgxTableColumnDef,
    NgxOutsideClick,
    NgxFocus
];

@NgModule({
    imports: [CommonModule, FormsModule, NgxTranslationsModule],
    declarations: [...DECLARATIONS_EXPORTS],
    exports: [...DECLARATIONS_EXPORTS]
})
export class NgxComponentKitModule {
}
